import React from 'react';
import Grid from '@material-ui/core/Grid';


function DrawerGridItemButtonContainer(props) {
  const {
    children,
  } = props;
  return (
    <Grid item xs={12}>
      <Grid container spacing={1} justify="flex-end">
        {children}
      </Grid>
    </Grid>
  );
}


export default DrawerGridItemButtonContainer;
